import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const race_id = 12408;
const token = '7d06b481-608a-4a9e-b1a3-7e9d4e9bb18f';

export default new Vuex.Store({
  state: {
    race_id: race_id,
    registration_open: true,
    token: token,
    amount: 2000,
    target: 628000,
    spent: 0,
    api_url: `https://api.reg.place/v1/events/dz-2021/races/${race_id}/heats?token=${token}&ts=${Date.now()}`,
    houses: [
      { number: "1",paid: false },
      { number: "1А",paid: false },
      { number: "2",paid: false },
      { number: "2А",paid: false },
      { number: "3",paid: false },
      { number: "3А",paid: false },
      { number: "4",paid: false },
      { number: "4А",paid: false },
      { number: "5",paid: false },
      { number: "5А",paid: false },
      { number: "6",paid: false },
      { number: "6А",paid: false },
      { number: "7",paid: false },
      { number: "7А",paid: false },
      { number: "8",paid: false },
      { number: "8А",paid: false },
      { number: "9",paid: false },
      { number: "9А",paid: false },
      { number: "10",paid: false },
      { number: "10А",paid: false },
      { number: "11",paid: false },
      { number: "11А",paid: false },
      { number: "12",paid: false },
      { number: "12А",paid: false },
      { number: "13",paid: false },
      { number: "13А",paid: false },
      { number: "14",paid: false },
      { number: "14А",paid: false },
      { number: "15",paid: false },
      { number: "15А",paid: false },
      { number: "16",paid: false },
      { number: "16А",paid: false },
      { number: "17",paid: false },
      { number: "17А",paid: false },
      { number: "18",paid: false },
      { number: "18А",paid: false },
      { number: "19",paid: false },
      { number: "19А",paid: false },
      { number: "20",paid: false },
      { number: "20А",paid: false },
      { number: "21",paid: false },
      { number: "21А",paid: false },
      { number: "22",paid: false },
      { number: "22А",paid: false },
      { number: "23",paid: false },
      { number: "23А",paid: false },
      { number: "24",paid: false },
      { number: "24А",paid: false },
      { number: "25",paid: false },
      { number: "25А",paid: false },
      { number: "26",paid: false },
      { number: "26А",paid: false },
      { number: "27",paid: false },
      { number: "27А",paid: false },
      { number: "28",paid: false },
      { number: "28А",paid: false },
      { number: "29",paid: false },
      { number: "29А",paid: false },
      { number: "30",paid: false },
      { number: "30А",paid: false },
      { number: "31",paid: false },
      { number: "31А",paid: false },
      { number: "32",paid: false },
      { number: "32А",paid: false },
      { number: "33",paid: false },
      { number: "33А",paid: false },
      { number: "34",paid: false },
      { number: "34А",paid: false },
      { number: "35",paid: false },
      { number: "35А",paid: false },
      { number: "36",paid: false },
      { number: "36А",paid: false },
      { number: "37",paid: false },
      { number: "37А",paid: false },
      { number: "38",paid: false },
      { number: "38А",paid: false },
      { number: "39",paid: false },
      { number: "39А",paid: false },
      { number: "40",paid: false },
      { number: "40А",paid: false },
      { number: "41",paid: false },
      { number: "41А",paid: false },
      { number: "42",paid: false },
      { number: "42А",paid: false },
      { number: "43",paid: false },
      { number: "43А",paid: false },
      { number: "44",paid: false },
      { number: "44А",paid: false },
      { number: "45",paid: false },
      { number: "45А",paid: false },
      { number: "46",paid: false },
      { number: "46А",paid: false },
      { number: "47",paid: false },
      { number: "47А",paid: false },
      { number: "48",paid: false },
      { number: "48А",paid: false },
      { number: "49",paid: false },
      { number: "49А",paid: false },
      { number: "50",paid: false },
      { number: "50А",paid: false },
      { number: "51",paid: false },
      { number: "51А",paid: false },
      { number: "52",paid: false },
      { number: "52А",paid: false },
      { number: "53",paid: false },
      { number: "53А",paid: false },
      { number: "54",paid: false },
      { number: "54А",paid: false },
      { number: "55",paid: false },
      { number: "55А",paid: false },
      { number: "56",paid: false },
      { number: "56А",paid: false },
      { number: "57",paid: false },
      { number: "57А",paid: false },
      { number: "58",paid: false },
      { number: "58А",paid: false },
      { number: "59",paid: false },
      { number: "59А",paid: false },
      { number: "60",paid: false },
      { number: "60А",paid: false },
      { number: "61",paid: false },
      { number: "61А",paid: false },
      { number: "62",paid: false },
      { number: "62А",paid: false },
      { number: "63",paid: false },
      { number: "63А",paid: false },
      { number: "64",paid: false },
      { number: "64А",paid: false },
      { number: "65",paid: false },
      { number: "65А",paid: false },
      { number: "66",paid: false },
      { number: "66А",paid: false },
      { number: "67",paid: false },
      { number: "67А",paid: false },
      { number: "68",paid: false },
      { number: "68А",paid: false },
      { number: "69",paid: false },
      { number: "69А",paid: false },
      { number: "70",paid: false },
      { number: "70А",paid: false },
      { number: "71",paid: false },
      { number: "71А",paid: false },
      { number: "72",paid: false },
      { number: "72А",paid: false },
      { number: "73",paid: false },
      { number: "73А",paid: false },
      { number: "74",paid: false },
      { number: "74А",paid: false },
      { number: "75",paid: false },
      { number: "75А",paid: false },
      { number: "76",paid: false },
      { number: "76А",paid: false },
      { number: "77",paid: false },
      { number: "77А",paid: false },
      { number: "78",paid: false },
      { number: "78А",paid: false },
      { number: "79",paid: false },
      { number: "79А",paid: false },
      { number: "80",paid: false },
      { number: "80А",paid: false },
      { number: "81",paid: false },
      { number: "81А",paid: false },
      { number: "82",paid: false },
      { number: "82А",paid: false },
      { number: "83",paid: false },
      { number: "83А",paid: false },
      { number: "84",paid: false },
      { number: "84А",paid: false },
      { number: "85",paid: false },
      { number: "85А",paid: false },
      { number: "86",paid: false },
      { number: "86А",paid: false },
      { number: "87",paid: false },
      { number: "87А",paid: false },
      { number: "88",paid: false },
      { number: "88А",paid: false },
      { number: "89",paid: false },
      { number: "89А",paid: false },
      { number: "90",paid: false },
      { number: "90А",paid: false },
      { number: "91",paid: false },
      { number: "91А",paid: false },
      { number: "92",paid: false },
      { number: "92А",paid: false },
      { number: "93",paid: false },
      { number: "93А",paid: false },
      { number: "94",paid: false },
      { number: "94А",paid: false },
      { number: "95",paid: false },
      { number: "95А",paid: false },
      { number: "96",paid: false },
      { number: "96А",paid: false },
      { number: "97",paid: false },
      { number: "97А",paid: false },
      { number: "98",paid: false },
      { number: "98А",paid: false },
      { number: "99",paid: false },
      { number: "99А",paid: false },
      { number: "100",paid: false },
      { number: "100А",paid: false },
      { number: "101",paid: false },
      { number: "101А",paid: false },
      { number: "102",paid: false },
      { number: "102А",paid: false },
      { number: "103",paid: false },
      { number: "103А",paid: false },
      { number: "104",paid: false },
      { number: "104А",paid: false },
      { number: "105",paid: false },
      { number: "105А",paid: false },
      { number: "106",paid: false },
      { number: "106А",paid: false },
      { number: "107",paid: false },
      { number: "107А",paid: false },
      { number: "108",paid: false },
      { number: "108А",paid: false },
      { number: "109",paid: false },
      { number: "109А",paid: false },
      { number: "110",paid: false },
      { number: "110А",paid: false },
      { number: "111",paid: false },
      { number: "111А",paid: false },
      { number: "112",paid: false },
      { number: "112А",paid: false },
      { number: "113",paid: false },
      { number: "113А",paid: false },
      { number: "114",paid: false },
      { number: "114А",paid: false },
      { number: "115",paid: false },
      { number: "115А",paid: false },
      { number: "116",paid: false },
      { number: "116А",paid: false },
      { number: "117",paid: false },
      { number: "117А",paid: false },
      { number: "118",paid: false },
      { number: "118А",paid: false },
      { number: "119",paid: false },
      { number: "119А",paid: false },
      { number: "120",paid: false },
      { number: "120А",paid: false },
      { number: "121",paid: false },
      { number: "121А",paid: false },
      { number: "122",paid: false },
      { number: "122А",paid: false },
      { number: "123",paid: false },
      { number: "123А",paid: false },
      { number: "124",paid: false },
      { number: "124А",paid: false },
      { number: "125",paid: false },
      { number: "125А",paid: false },
      { number: "126",paid: false },
      { number: "126А",paid: false },
      { number: "127",paid: false },
      { number: "127А",paid: false },
      { number: "128",paid: false },
      { number: "128А",paid: false },
      { number: "129",paid: false },
      { number: "129А",paid: false },
      { number: "130",paid: false },
      { number: "130А",paid: false },
      { number: "131",paid: false },
      { number: "131А",paid: false },
      { number: "132",paid: false },
      { number: "132А",paid: false },
      { number: "133",paid: false },
      { number: "133А",paid: false },
      { number: "134",paid: false },
      { number: "134А",paid: false },
      { number: "135",paid: false },
      { number: "135А",paid: false },
      { number: "136",paid: false },
      { number: "136А",paid: false },
      { number: "137",paid: false },
      { number: "137А",paid: false },
      { number: "138",paid: false },
      { number: "138А",paid: false },
      { number: "139",paid: false },
      { number: "139А",paid: false },
      { number: "140",paid: false },
      { number: "140А",paid: false },
      { number: "141",paid: false },
      { number: "141А",paid: false },
      { number: "142",paid: false },
      { number: "142А",paid: false },
      { number: "143",paid: false },
      { number: "143А",paid: false },
      { number: "144",paid: false },
      { number: "144А",paid: false },
      { number: "145",paid: false },
      { number: "145А",paid: false },
      { number: "146",paid: false },
      { number: "146А",paid: false },
      { number: "147",paid: false },
      { number: "147А",paid: false },
      { number: "148",paid: false },
      { number: "148А",paid: false },
      { number: "149",paid: false },
      { number: "149А",paid: false },
      { number: "150",paid: false },
      { number: "150А",paid: false },
      { number: "151",paid: false },
      { number: "151А",paid: false },
      { number: "152",paid: false },
      { number: "152А",paid: false },
      { number: "153",paid: false },
      { number: "153А",paid: false },
      { number: "154",paid: false },
      { number: "154А",paid: false },
      { number: "155",paid: false },
      { number: "155А",paid: false },
      { number: "156",paid: false },
      { number: "156А",paid: false },
      { number: "157",paid: false },
      { number: "157А",paid: false }
    ]
  },
  getters: {
    countPaid: (state) => {
      return state.houses.filter(house => house.paid).length
    },
    totalAmount: (state, getters) => {
      return getters.countPaid * state.amount
    }
  },
  mutations: {
    setPaid(state, number) {
        let house = state.houses.find((h) => number == h.number);
        house.paid = true
    },
    setStage(state, stage) {
      state.registration_open = 'open' == stage;
    }
  },
  actions: {
    setPaid(context, number) {
      context.commit('setPaid', number)
    },
    setStage(context, stage) {
      context.commit('setStage', stage)
    }
  },
  modules: {
  }
})
